if (!customElements.get('bundle-atc-button')) {
  class BundleAtcButton extends HTMLElement {
    connectedCallback() {
      this._btn = this.querySelector('.smg-bundle-up__atc-btn');
      this._feedback = this.querySelector('.smg-bundle-up__atc-feedback');

      if (this._btn) {
        this._btn.addEventListener('click', this._handleClick.bind(this));
      }
    }

    _handleClick() {
      const variantId = this._btn.dataset.variantId;
      const sellingPlanId = this._btn.dataset.sellingPlanId;
      if (!variantId) return;

      this._setLoading(true);
      this._setFeedback('');

      const body = {
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      };

      if (sellingPlanId) {
        body.selling_plan = sellingPlanId;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then((res) => {
          if (!res.ok) return res.json().then((err) => Promise.reject(err));
          return res.json();
        })
        .then((response) => {
          this._setFeedback('Added!');
          this._dispatchCartUpdate(response);

          /* Limpiar feedback luego de 2.5s */
          clearTimeout(this._feedbackTimer);
          this._feedbackTimer = setTimeout(() => this._setFeedback(''), 2500);
        })
        .catch((err) => {
          const msg =
            (err && err.description) ||
            (err && err.message) ||
            'Something went wrong. Please try again.';
          this._setFeedback(msg);
        })
        .finally(() => {
          this._setLoading(false);
        });
    }

    _setLoading(isLoading) {
      if (!this._btn) return;
      if (isLoading) {
        this._btn.classList.add('smg-bundle-up__atc-btn--loading');
        this._btn.setAttribute('aria-busy', 'true');
      } else {
        this._btn.classList.remove('smg-bundle-up__atc-btn--loading');
        this._btn.removeAttribute('aria-busy');
      }
    }

    _setFeedback(msg) {
      if (this._feedback) this._feedback.textContent = msg;
    }

    /**
     * Dispara el evento nativo de Shopify para actualizar el cart drawer/icon.
     */
    _dispatchCartUpdate(response) {
      if (response && response.sections) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }
      }

      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

          /* Compatibilidad con theme Horizon */
          const countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach((el) => {
            el.textContent = cart.item_count;
          });

          /* Abrir cart drawer si existe y renderContents no lo hizo */
          const drawerToggle = document.getElementById('cart-icon-bubble');
          if (drawerToggle) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open(drawerToggle);
            }
          }
        });
    }
  }

  customElements.define('bundle-atc-button', BundleAtcButton);
}
